import { Grid, Typography } from '@mui/material';
import styled from 'styled-components';

export const CheckoutSummaryGrid = styled(Grid) <{ $isMd: boolean }>`
  padding: ${props => props.theme.spacing(3)};
  ${props =>
    props.$isMd &&
    `border-top: 1px solid ${props.theme.palette.grey[300]};
  border-bottom: 1px solid ${props.theme.palette.grey[300]};`}
  background-color: #fff;
  ${props => !props.$isMd && `border: 1px solid ${props.theme.palette.grey[300]};`}
  ${props => !props.$isMd && `border-radius: 14px;`}

  ${props => props.theme.breakpoints.down('md')} {
    background-color: ${props => props.theme.palette.grey[50]};
  }
`;

export const StickyWrapper = styled.div`
  ${props => props.theme.breakpoints.up('xs')} {
    position: sticky;
    top: 80px;
  }
`;

export const SavedAmount = styled(Typography)`
display: flex;
align-items: center;
font-weight: 500;

& svg {
margin-right:  ${props => props.theme.spacing(1)};
}

`;
